import { getFromFirebase, handleGetColecction, handleSelectedFirebase, objectToArray } from '@/constantes/helpers'
import firebase from '@/firebase'
import { FS_COLLECTIONS } from '@/firebase'
const db = firebase.firestore()
import { FILTROS_REPORTE } from '@/constantes/reportes'

const docRef = (id_franquicia) =>  db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(id_franquicia)
.collection(FS_COLLECTIONS.GASTOS)

const newObject = (objeto, campo) => {

  const newO = {
    seleccionado:objeto.seleccionado,
    id: objeto[campo] ? objeto[campo].id : null,
  }

  return newO

}

/**
 * @param {firebase.firestore.Query<firebase.firestore.DocumentData>} docRef
 * @param {FILTROS_REPORTE} filtros
 */
const obtenerFiltrosAdicionalesGastos = (docRef, filtros) => {
  
  const {sucursal, colaborador} = filtros.filtro2
  const {categoria, concepto} = filtros.filtro1

  docRef = handleSelectedFirebase(docRef,sucursal,'id_sucursal')
  docRef = handleSelectedFirebase(docRef,colaborador,'id_colaborador')
  docRef = handleSelectedFirebase(docRef,newObject(categoria,'categoria'),'categoria.id')
  docRef = handleSelectedFirebase(docRef,newObject(concepto,'concepto'),'concepto.id')

  return docRef

}

const store = {
  state: {
    gastos: {},
  },
  getters: {
    gastos: state => {
      return state.gastos
    },
    gastosPorSucursal: (state,getters) => {
      
      const gastos = {}

      for(const i in state.gastos){
        if(state.gastos[i].id_sucursal===getters.sucursalActual){
          gastos[i] = state.gastos[i]
        }
      }

      return gastos

    },
  },
  mutations: {
    ASIGNA_GASTOS(state, gastos) {
      state.gastos = gastos
    },
  },
  actions: {
      async guardarGasto({getters},gasto){

        gasto.fecha_alta = new Date()
        gasto.id_sucursal = getters.sucursalActual

        return await docRef(getters.franquicia.id).add(gasto)

      },
      async actualizarGasto({getters}, payload){

        const {id_gasto, gasto} = payload

        return await docRef(getters.franquicia.id).doc(id_gasto).update(gasto)

      },
      async obtenerGasto({getters},id_gasto){
        return await getFromFirebase(docRef(getters.franquicia.id).doc(id_gasto))
      },
      async eliminarGasto({getters},id_gasto){
        return await docRef(getters.franquicia.id).doc(id_gasto).delete()
      },
      async obtenerGastos({getters,commit}, fecha){

        return new Promise(resolve => {
          db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
          .collection(FS_COLLECTIONS.GASTOS_INDICES).doc(fecha).onSnapshot(doc => {
            
            commit('ASIGNA_GASTOS',doc.data() || {}),
            resolve()

          })
        })

      },
      async obtenerGastosFiltrados({getters},filtros){

        const fechaDel = filtros.filtro1.fecha.del.fecha
        const fechaAl = filtros.filtro1.fecha.al.fecha
        const campo = 'fecha_alta'

        let docRef = db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
        .collection(FS_COLLECTIONS.GASTOS).where(campo,'>=',fechaDel).where(campo,'<=',fechaAl)
        
        docRef = obtenerFiltrosAdicionalesGastos(docRef,filtros)

        return await handleGetColecction(docRef)

      }
  }
}

export default store



// WEBPACK FOOTER //
// ./src/store/gastos/index.js